export const userDetailsReducerKey = 'userDetailsReducerKey';

export const updateUserDetailsType = 'updateUserDetailsType';
